export const Colors = {
  // primary: '#007bff',
      primary:'#00778B',
  // secondary: '#00778B',
      secondary:'#029ab4',

  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#17a2b8',
  light: '#f8f9fa',
  dark: '#343a40',
  accent_blue: '#56dae0',
  // grey: '#6c757d',
  grey: '#e8eaed',
  green: '#28a745',
  yellow: '#ffd700',
  orange: '#fd7e14'
} as const;

export default Colors;
